<template>
  <div class="layout">
    <div class="wd-100p" style="min-height: 100vh">
      <div
        class="ivu-layout-header"
        :style="
          `
          width: 100%;
          color: white; ${headerBg}`
        "
      >
        <div class="pd-y-20 pd-x-40">
          <div>
            <h5 class="text-white mg-b-0">{{ name }}</h5>
          </div>
        </div>
      </div>
      <div
        class="ivu-layout-content"
        style="
          margin: 0px 20px 0px;
          background: rgb(255, 255, 255);
          min-height: 500px;
        "
      >
        <div>
          <div v-if="$store.state.app.isMobile" style="position: fixed; bottom: 0; left: 0; right: 0; padding-bottom: " class="align-items-center bd-t bg-gray-100 d-flex pd-3">
            <div>
              <span v-if="mode == 'waiting'">эхлэхэд </span>
                <span v-else-if="mode == 'filling'">дуусахад - </span>
                <span id="countdown" style="font-size: 16px"></span>
            </div>
            <div class="mg-l-auto" v-if="mode == 'filling'">
                <div @click="finishFormConfirm()" class="finish-btn">
                  <span>Дуусгах</span>
                </div>
            </div>
          </div>
          <div class="d-flex flex-row">
            <div v-if="!$store.state.app.isMobile" class="wd-15p" style="border-right: 1px solid #e1e1e1">
              <div class="card-header" v-if="mode != 'filling'">
                <a href="/" class="ivu-btn ivu-btn-default">
                  <feather type="chevron-left" />
                  Буцах
                </a>
              </div>

              <div class="d-flex pd-10">
                <div>
                  <div class="avatar avatar-sm mg-r-10">
                    <img :src="`${$store.state.user.userInfo.avator}`" />
                  </div>
                </div>
                <div>
                  <h6>{{ $store.state.user.userInfo.fullName }}</h6>
                  <span class="tx-12">{{
                    $store.state.user.userInfo.register
                  }}</span>
                </div>
              </div>
              <table
                class="wd-100p pd-10 table"
                style="background: rgba(0, 0, 0, 0.1)"
              >
                <tbody>
                  <tr>
                    <td class="text-right">Салбар:</td>
                    <td>
                      <h6>{{ $store.state.user.userInfo.depart }}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right">И-мэйл:</td>
                    <td>
                      <h6>{{ $store.state.user.userInfo.mail }}</h6>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-right">Утас:</td>
                    <td>
                      <h6>{{ $store.state.user.userInfo.mobile }}</h6>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="pd-10">
                <div
                  v-for="(s, si) in sections"
                  :key="si"
                  class="row no-gutters mg-b-10"
                >
                  <div class="wd-100p text-muted">
                    {{ romanize(si + 1) }}. {{ s.name }}
                  </div>
                  <div
                    v-for="(q, i) in questions.filter(x => x.sn.id == s.id)"
                    :key="i"
                    class="col-2 text-right"
                  >
                    <a
                      :href="`#anch_${q.id}`"
                      class="qanchors-outer"
                      :class="{ invalid: q.rq != null && q.rq.v }"
                    >
                      <div class="qanchors">{{ i + 1 }}</div>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="p-sm text-center"
                style="
                  background: rgba(255, 153, 0, 0.3);
                  color: rgba(255, 87, 34);
                "
              >
                <div v-if="mode == 'waiting'">эхлэхэд</div>
                <div v-else-if="mode == 'filling'">дуусахад</div>
                <span id="countdown" style="font-size: 26px"></span>
              </div>
              <div class="p-sm" v-if="mode == 'filling'">
                <div @click="finishFormConfirm()" class="finish-btn">
                  <span>Дуусгах</span>
                </div>
              </div>
            </div>
            <div
              id="section-container"
              class="pd-10 flex-grow-1"
              :style="`overflow: auto; height: calc(100vh - ${$store.state.app.isMobile?'128px':'64px'})`"
            >
              <div
                v-if="info != null || info != ''"
                v-html="info"
                class="md-10"
              ></div>
              <div
                v-if="mode == 'waiting' || mode == 'filling'"
                class="ivu-collapse"
              >
                <div class="card" v-for="(s, i) in sections" :key="i">
                  <div class="card-header bg-light pd-10">
                    {{ romanize(i + 1) }}. {{ s.name }}
                  </div>
                  <div class="card-body">
                    <div
                      v-if="s.info != ''"
                      v-html="s.info"
                      class="text-muted p-t-sm"
                    ></div>
                    <div class="ivu-collapse-content-box">
                      <div
                        v-for="(q, qi) in questions.filter(
                          x => x.sn.id == s.id
                        )"
                        :key="qi"
                        :class="`q-item m-b-sm q-type-${q.t}`"
                      >
                        <div
                          :id="`anch_${q.id}`"
                          class="q-title"
                          v-html="qi + 1 + '. ' + q.s1"
                        ></div>
                        <div
                          v-if="q.at != null || q.s2 != ''"
                          style="background: rgba(0, 0, 0, 0.03)"
                          class="p-xs m-l-md"
                        >
                          <div class="text-muted" v-html="q.s2"></div>
                          <a
                            @click="showAttach(q.at.id)"
                            v-if="q.at != null"
                            style="color: green"
                            role="button"
                          >
                            <i class="ivu-icon ivu-icon-md-attach"></i>файл
                            харах
                          </a>
                        </div>
                        <div
                          v-if="q.rq != null && q.rq.v"
                          style="background: rgba(255, 0, 0, 0.03); color: red"
                          class="mg-t-5 mg-b-5 pd-5 mg-l-20"
                        >
                          {{ q.rq.t }}
                        </div>
                        <div
                          v-for="(a, ai) in q.a"
                          :key="ai"
                          class="q-answers mg-l-20"
                        >
                          <div
                            v-if="q.t == 3 || q.t == 4"
                            class="d-flex align-items-center"
                          >
                            <div
                              @click="submitQuestion(q, a)"
                              style="width: 20px"
                            >
                              {{ alphabetize(ai) }}.
                            </div>
                            <div class="ivu-col" style="margin-top: -2px">
                              <a @click="submitQuestion(q, a)">
                                <feather
                                  class="wd-20-f ht-20-f tx-primary"
                                  :type="`${getFeather(q, a)}`"
                                ></feather>
                                <!-- <i :class="`ivu-icon ivu-icon-${getIcon(q,a)}`"></i> -->
                              </a>
                            </div>
                            <div
                              class="wd-80p pd-l-5"
                              @click="submitQuestion(q, a)"
                            >
                              <div role="button" v-html="a.s1"></div>
                              <a
                                @click.stop="showAttach(a.at.id)"
                                v-if="a.at != null"
                                style="font-size: 12px; color: green"
                                role="button"
                              >
                                <feather type="paperclip"></feather>файл харах
                              </a>

                              <Input
                                v-if="a.isResponse && a.isFilled"
                                @change="submitQuestion(q, a, a.str)"
                                v-model="a.str"
                                class="w-full"
                                placeholder="Энд бичнэ үү"
                              />
                            </div>
                          </div>
                          <template v-else-if="q.t == 1 || q.t == 7">
                            <Input
                              @change="submitQuestion(q, a, a.s1)"
                              v-model="a.s1"
                              v-if="q.t == 1"
                              class="w-full"
                              placeholder="бичнэ үү"
                            />
                            <InputNumber
                              @change="submitQuestion(q, a, a.s1)"
                              v-model="a.s1"
                              v-else-if="q.t == 7"
                              placeholder="тоон утгаар хариулна уу"
                              style="width: 200px"
                            />
                          </template>
                          <template v-else-if="q.t == 11">
                            <Input
                              @change="submitQuestion(q, a, a.s1)"
                              v-model="a.s1"
                              type="textarea"
                              class="w-full m-b-sm"
                              :rows="4"
                              placeholder="бичнэ үү"
                            />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="mode == 'done'" class="ivu-row-flex">
                <div>
                  <h1>Саналаа өгсөнд баярлалаа</h1>
                  <br />
                  <a href="/">Эхлэл</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <b-overlay :show="busy" no-wrap>
          <template #overlay>
            <div
              v-if="processing"
              class="text-center p-4 bg-secondary text-light rounded"
            >
              <b-icon icon="info" font-scale="4"></b-icon>
              <div class="mb-3">Түр хүлээнэ үү...</div>
              <b-progress
                min="1"
                max="20"
                :value="18"
                variant="warning"
                height="5px"
                class="mx-n4 rounded-0"
              ></b-progress>
            </div>
            <div
              v-else
              ref="dialog"
              tabindex="-1"
              role="dialog"
              aria-modal="false"
              aria-labelledby="form-confirm-label"
              class="text-center p-3"
            >
              <p>
                <strong id="form-confirm-label">Итгэлтэй байна уу?</strong>
              </p>
              <div class="d-flex">
                <b-button
                  variant="outline-danger"
                  class="mr-3"
                  @click="busy = false"
                  >Үгүй</b-button
                >
                <b-button
                  variant="outline-success"
                  @click="finishForm()"
                  >Тийм</b-button
                >
              </div>
            </div>
          </template>
        </b-overlay>

    <!-- <attachment-drawer :prms="attachDrawerParams" @on-attachment-closed="attachmentDrawerClose()"></attachment-drawer> -->
  </div>
</template>
<style>
.finish-btn {
  border: 1px solid #ffad33;
  border-radius: 3px;
  background: #ffad33;
  padding: 5px;
  text-align: center;
  color: white;
  text-transform: uppercase;
  cursor: pointer;
}
.qanchors-outer {
  border: 1px solid #e1e1e1;
  margin: 3px 2px;
  border-radius: 3px;
  display: block;
}
.qanchors {
  width: 100%;
  font-weight: 700;
  padding: 5px 5px;
}
.qanchors-outer.invalid {
  border: 1px solid rgba(255, 0, 0, 0.2);
}
.qanchors-outer.invalid .qanchors {
  background: rgba(255, 0, 0, 0.03);
  color: red;
}
.qanchors:hover {
  background: rgba(0, 0, 0, 0.2);
}

.q-item .q-title {
  font-size: 16px;
  font-weight: 500;
}
.q-type-3 .q-answers,
.q-type-4 .q-answers {
  border-top: 1px dashed #e1e1e1;
}
.q-answers a {
  font-size: 26px;
}
</style>

<script>
// import { GetQuestion, CheckQuestion, CheckQuestionPost, formEnd } from "@/api/form";

// import { timeDiffFromNow } from "@/api/learn";

// import { servertime } from "@/api/dynamic";
import { request } from "@/api/all";
import { alphabetize, romanize } from "@/libs/util";
import { hasOneOf } from "@/libs/tools";

import "element-ui/lib/theme-chalk/index.css";
import { Input, InputNumber } from "element-ui";

const moment = require("moment");

var myVar;
var myVarFilling;
// import AsyncLoadError from "@/view/component/AsyncLoadError";
// import AsyncLoading from "@/view/component/AsyncLoading";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
export default {
  components: {
    Input,
    InputNumber,
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
    // attachmentDrawer: () => ({
    //   component: import("@/view/task/component/drawer/attachment.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 300,
    //   timeout: 20000
    // })
  },
  name: "sanalasuulga",
  data() {
    return {
      processing: false,
      busy: false,

      attachDrawerParams: {
        id: 0,
        field: "",
        value: ""
      },
      fileDialog: {
        show: false,
        id: 0
      },

      mode: "",
      name: "",
      questions: [],
      sections: [],
      timeLimit: 0,
      info: "",
      formId: 0,
      timer: {
        wait: 0,
        duration: 0,
        counter: 0,
        counterFilling: 0
      },
      headerBg:
        "background-image: linear-gradient(80deg, rgb(1, 33, 105), rgb(11 0 98));"
    };
  },
  mounted() {
    if (this.$store.state.app.activeGroup.id == 9157) {
      this.headerBg =
        "background-image: linear-gradient( 80deg, rgb(1, 33, 105), rgb(4, 106, 56) );";
    }
    let self = this;
    if (this.$route.params.id > 0) {
      //this.name = this.$route.params.name;
      this.init(this.$route.params.id);

      if (this.$store.state.signalr.osrCon != "") {
        this.$store.state.signalr.osrCon.on("onFormUpdated", form => {
          self.timer.wait = 0;
          self.timer.duration = 0;
          self.timer.counter = 0;
          clearTimeout(myVar);
          clearTimeout(myVarFilling);
          self.init(form.id);
        });
      }
    }
  },
  methods: {
    init(id) {
      let self = this;
      this.formId = id;
      //GetQuestion({formID: id})

      request({
        params: { form: id },
        api: { method: "get", url: "Form/GetLatestResponse" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.sections = _.orderBy(res.data.sections, ["ord"], ["asc"]);
          this.timeLimit = res.data.timeLimit;
          this.info = res.data.info;
          this.name = res.data.name;

          this.questions = res.data.questions.map(q => {
            if (q.t == 7 && q.a.length > 0) {
              if (q.a[0].s1 == "") {
                q.a[0].s1 = 0;
              } else {
                q.a[0].s1 = parseInt(q.a[0].s1, 10);
              }
            }
            return q;
          });

          if (this.timeLimit == 0) {
            this.timer.wait = res.data.startDate;
            let _end = res.data.endDate;
            var interval = 1000;
            myVar = setInterval(function() {
              if (self.timer.counter == 0 || self.timer.counter == 60) {
                request({
                  params: { date: res.data.startDate },
                  api: { method: "get", url: "Public/TimeDiffFromNow" },
                  store: this.$store
                }).then(res => {
                  if (res != false) {
                    if (res.data.diff > 0) {
                      self.timer.counter = 1;
                      self.mode = "waiting";
                      self.displayTime(res.data.diff);
                      self.timer.wait = res.data.diff;
                    } else {
                      clearTimeout(myVar);
                      self.mode = "filling";
                      self.timer.counter = 0;
                      self.startFill(_end);
                    }
                  }
                });
              } else {
                if (self.timer.wait > 0) {
                  self.timer.wait--;
                  self.displayTime(self.timer.wait);
                } else {
                  clearTimeout(myVar);
                  self.timer.counter = 0;
                  self.startFill(_end);
                }
              }
              self.timer.counter++;
            }, interval);
          }
        } else {
          this.mode = "done";
        }
      });
    },
    displayTime(diff) {
      $("#countdown").text(new Date(diff * 1000).toISOString().substr(11, 8));
      //$('#countdown').text((Math.floor((diff /360 ))+'').padStart(2, '0') + " : " + (Math.floor((diff /60 ))+'').padStart(2, '0') + " : " + (Math.floor((diff % 60 ))+'').padStart(2, '0'));
    },
    startFill(end) {
      let self = this;

      this.timeLimit = 0;
      //this.timer.duration= end;
      var interval = 1000;
      

      myVarFilling = setInterval(function() {
        
        
        if (self.timer.counterFilling == 0 || self.timer.counterFilling == 60) {
          
          request({
            params: { date: end },
            api: { method: "get", url: "Public/TimeDiffFromNow" },
            store: this.$store
          }).then(res => {
            if (res != false) {
              if (res.data.diff > 0) {
                self.timer.counterFilling = 1;
                self.mode = "filling";
                self.displayTime(res.data.diff);
                self.timer.duration = res.data.diff;
              } else {
                clearTimeout(myVarFilling);
                self.finishForm();
                self.mode = "done";
              }
            }
          });
        } else {
          if (self.timer.duration > 0) {
            self.timer.duration--;
            self.displayTime(self.timer.duration);
          } else {
            clearTimeout(myVarFilling);
            self.finishForm();
            self.mode = "done";
          }
        }
        self.timer.counterFilling++;
      }, interval);
    },
    getFeather(q, a) {
      let rv = "";
      if (a.isFilled) {
        if (q.t == 3) {
          rv = "check-square";
        } else {
          rv = "check-circle";
        }
      } else {
        if (q.t == 3) {
          rv = "square";
        } else {
          rv = "circle";
        }
      }
      return rv;
    },
    getIcon(q, a) {
      let rv = "";
      if (a.isFilled) {
        if (q.t == 3) {
          rv = "md-checkbox";
        } else {
          rv = "md-radio-button-on";
        }
      } else {
        if (q.t == 3) {
          rv = "md-square-outline";
        } else {
          rv = "md-radio-button-off";
        }
      }
      return rv;
    },
    submitQuestion(q, a, str) {
      if (this.mode == "filling") {
        let _data = {
          formId: this.formId,
          questionId: q.id,
          answerId: a.id,
          str: str
        };
        if (q.t == 1 || q.t == 7 || q.t == 11) {
          _data = {
            formId: this.formId,
            questionId: q.id,
            str: str
          };
        } else if ((q.t == 3 || q.t == 4) && a.isResponse && a.isFilled) {
          _data = {
            formId: this.formId,
            questionId: q.id,
            answerId: a.id,
            str: str
          };
        }
        if (q.t == 11) {
          request({
            api: { method: "post", url: "Form/CheckQuestionPost" },
            data: _data,
            store: this.$store
          }).then(res => {
            if (res != false) {
            }
          });
        } else {
          //CheckQuestion(_data)

          request({
            api: { method: "post", url: "Form/CheckQuestion" },
            params: _data,
            store: this.$store
          }).then(res => {
            if (res != false) {
              if (q.t == 3 || q.t == 4) {
                if (q.t == 4) {
                  q.a.forEach(e => {
                    e.str = e.id == a.id ? e.str : "";
                    e.isFilled = e.id == a.id;
                  });
                }
                // else if(a.isResponse && str==undefined){
                //   a.isFilled= !a.isFilled;
                // }
                else {
                  if (str == undefined) {
                    a.str = "";
                    a.isFilled = !a.isFilled;
                  }
                }
              }
            }
          });
        }
      } else if (this.mode == "waiting") {
        this.$Notice.warning({
          top: 50,
          duration: 3,
          title: "Санамж",
          desc: "Эхлэх болоогүй байна"
        });
      }
    },
    alphabetize(i) {
      return alphabetize(i);
    },
    romanize(i) {
      return romanize(i);
    },
    showAttach(id) {
      //   this.attachDrawerParams.value = id;
      //   this.attachDrawerParams.id = id;
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    attachmentDrawerClose() {
      this.attachDrawerParams.value = "";
      this.attachDrawerParams.id = 0;
    },
    scrollToAnchor(q) {
      var aTag = $("#anch_" + q.id);
      $("#section-container").animate({ scrollTop: aTag.offset().top }, "fast");
    },
    finishForm() {
      this.processing= true;
      //formEnd({ id: this.formId })
      request({
        api: { method: "post", url: "Form/FormEnd" },
        data: {
          id: this.formId
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.processing=false;
          this.busy=false;

          if (res.data.result == 1) {
            $("#countdown").text("ДУУССАН");
            clearTimeout(myVar);
            clearTimeout(myVarFilling);
            this.mode = "done";
          } else if (res.data.result == 0) {
            this.questions.forEach(q => {
              q.rq.v = hasOneOf(res.data.questions, [q.id]);
            });
          }
        }
      });
    },
    finishFormConfirm() {
      this.busy = true;
      // if (confirm("Санал асуулгыг дуусгах уу ?")) {
      //   this.finishForm();
      // }
    }
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data());
  }
};
</script>
<style>
.flex-container {
  height: 70vh;
  padding: 0;
  margin: 0;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
